// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"LongTextCardModule_cardContainer__3AAQe","cardHeader":"LongTextCardModule_cardHeader__3AZaH"};